<template>
  <sweet-modal title="Add Allocations" blocking width="940" ref="modal" class="modal" v-on:close="close">
    <h4>{{$t('settings_accountThink_GLAccounts_accountName')}}: {{accountName}}</h4>
    <el-form :model="form2" size="mini" ref="form2" status-icon label-position="left">
      <div class="content">
        <div class="content__head">
          <div>
            <el-form-item
                prop="amount"
                style="margin-bottom:0;">
              <div style="display: flex; align-items: center;">
                <div>
                  <money
                      :readonly="true"
                      v-model="amount"
                      v-bind="money"
                      class="amount-input readonly">
                  </money>
                </div>
                <span style="margin-left: 10px;">{{DRCRCode === 'DR' ? $t('settings_accountThink_GLAccounts_debit') : $t('settings_accountThink_GLAccounts_credit')}}</span>
              </div>
            </el-form-item>
            <el-form-item
                prop="foreignAmount"
                style="margin-bottom:0; margin-top: 15px;">
              <div style="display: flex; align-items: center;">
                <div>
                  <money
                      :readonly="true"
                      v-model="foreignAmount"
                      v-bind="moneyForeign"
                      class="amount-input readonly">
                  </money>
                </div>
              </div>
            </el-form-item>
          </div>
          <h4>Transaction ID: <span style="color: #409EFF; cursor: pointer;" @click="$emit('openJournal')">{{transactionNo}}</span></h4>
        </div>
        <el-form-item
            prop="rate"
            style="margin-bottom:15px; margin-top: 15px;">
          <div style="display: flex; align-items: center;">
                <span style="margin-right: 10px;">
                  Rate
                </span>
            <div>
              {{rate }}
            </div>
          </div>
        </el-form-item>
        <el-form-item
            :label="$t('settings_accountThink_GLAccounts_date')"
            prop="date">
          <el-date-picker type="date"
                          class="date-input"
                          format="d MMM yy"
                          readonly
                          :value="date"
                          value-format="DD-MM-yyyy"
                          :picker-options="pickerOptions2">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="clear: both; margin-top:15px;" :label="$t('modal_description')" prop="transactionDescription">
          <el-input
              type="textarea"
              :rows="2"
              v-model="form2.transactionDescription">
          </el-input>
        </el-form-item>
      </div>
      <el-table
          size="mini"
          border
          :data="form2.items"
          style="width: 100%"
          @cell-click="cellClick">
        <el-table-column :label="'Amount ' + moneyForeign.suffix">
          <template slot-scope="scope">
            <el-form-item label-width="0"
                          :prop="'items.' + scope.$index + '.foreignAmount'"
                          :rules="[
                                    // { required: true, message: 'Field is required', trigger: 'blur'},
                                    { validator: validateAmount, trigger: 'blur' }
                                  ]">
              <el-input v-show="false" type="number" v-model="scope.row.foreignAmount" size="mini"></el-input>
              <money v-model="scope.row.foreignAmount" v-bind="moneySimple" class="item-amount-input" @input="changeForeignAmount(scope.row)"></money>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column :label="'Amount ' + money.suffix">
          <template slot-scope="scope">
            <el-form-item label-width="0"
                          :prop="'items.' + scope.$index + '.amount'"
                          :rules="[
                                    // { required: true, message: 'Field is required', trigger: 'blur'},
                                    { validator: validateAmount, trigger: 'blur' }
                                  ]">
              <el-input v-show="false" type="number" disabled v-model="scope.row.amount" size="mini"></el-input>
              <money v-model="scope.row.amount" disabled v-bind="moneySimple" class="item-amount-input"></money>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="Description">
          <template slot-scope="scope">
            <el-form-item label-width="0"
                          :prop="'items.' + scope.$index + '.description'">
              <el-input type="text" v-model="scope.row.transactionDescription" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="Allocated To">
          <template slot-scope="scope">
            <el-form-item label-width="0"
                          :prop="'items.' + scope.$index + '.entityTypeId'"
                          :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
              <el-select
                  v-model="scope.row.entityTypeId"
                  size="mini"
                  placeholder="Type"
                  @change="selectEntityType(scope)">
                <el-option
                    v-for="item in entityTypeList"
                    :key="item.id"
                    :disabled="item.disabled"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="BU">
          <template slot-scope="scope">
            <el-form-item label-width="0"
                          :prop="'items.' + scope.$index + '.buId'"
                          :rules="{ required: true, message: 'Field is required', trigger: 'blur' }">
              <el-select
                  v-model="scope.row.buId"
                  :disabled="!scope.row.entityTypeId"
                  size="mini"
                  placeholder="BU"
                  @change="selectBu(scope)">
                <el-option
                    v-for="item in scope.row.buList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="WHS-ENG-PRO">
          <template slot-scope="scope">
            <el-form-item
                v-if="scope.row.entityTypeId !== 2"
                label-width="0"
                :prop="'items.' + scope.$index + '.parentId'">
              <el-select
                  v-model="scope.row.parentId"
                  :disabled="!scope.row.buId"
                  size="mini"
                  placeholder="WHS-ENG-PRO"
                  @change="selectParent(scope)">
                <el-option
                    v-for="item in scope.row.parentList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="Task">
          <template slot-scope="scope">
            <el-form-item label-width="0"
                          :prop="'items.' + scope.$index + '.taskId'">
              <el-select
                  v-model="scope.row.taskId"
                  :disabled="!scope.row.taskList.length"
                  size="mini"
                  placeholder="Task"
                  @change="selectTask(scope)">
                <el-option
                    v-for="item in scope.row.taskList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="EU">
          <template slot-scope="scope">
            <el-form-item label-width="0"
                          :prop="'items.' + scope.$index + '.userId'">
              <el-select
                  v-model="scope.row.userId"
                  :disabled="!scope.row.taskId"
                  size="mini"
                  placeholder="EU">
                <el-option
                    v-for="item in scope.row.userList"
                    :key="item.userId"
                    :label="item.userFullName"
                    :next-icon="false"
                    :value="item.userId">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex; justify-content: space-between;">
        <el-card style="margin-top: 20px; max-width: 400px; width:100%;">
          <div style="display: flex; justify-content: space-between">
            <div>
              <h4 style="display: flex; flex-direction: column;">
                <span>Total Allocations: </span>
                <span> {{formatPrice(totalAmount)}}</span>
              </h4>
              <h4 :style="{color: ifTotalAmountBigger() ? 'red' : '#000'}" style="display: flex; flex-direction: column;">
                <span>Balance to Allocate: </span>
                <span> {{formatPrice(balanceToAllocate())}}</span>
              </h4>
            </div>
            <div>
              <h4 style="display: flex; flex-direction: column;">
                <span>Total Allocations in {{moneyForeign.suffix}}: </span>
                <span> {{formatPrice(totalAmountForeign)}}</span>
              </h4>
              <h4 :style="{color: ifTotalAmountForeignBigger() ? 'red' : '#000'}" style="display: flex; flex-direction: column;">
                <span style="height:21px;"></span>
                <span> {{formatPrice(balanceToAllocateForeign())}}</span>
              </h4>
            </div>
          </div>
          <p>Posted to Subsidiary ledger</p>
        </el-card>
        <el-form-item class="modal__btn" style="display: flex; align-items: flex-end; margin-bottom: 0" >
          <el-button :disabled="ifTotalAmountBigger() || ifTotalAmountForeignBigger()" @click="addItem('form2')" type="primary" size="medium">{{$t('general_addLine')}}</el-button>
          <el-button type="primary" :disabled="ifTotalAmountBigger() || ifTotalAmountForeignBigger()" @click="addAllocations('form2')" size="medium">{{$t('general_add')}}</el-button>
        </el-form-item>
      </div>
    </el-form>
  </sweet-modal>
</template>

<script>
import {SweetModal} from "@totalflow4/tfsweet-modal-vue";
import {Money, VMoney} from "v-money";
import axios from "axios";
import moment from "moment";
export default {
  name: "COAAddMultiCurrencyAllocationModal",
  components: {
    SweetModal,
    Money
  },
  props: {
    amount: {
      type: Number,
      default: 0
    },
    foreignAmount: {
      type: Number,
      default: 0
    },
    transactionNo: {
      type: String,
      default: null
    },
    DRCRCode: {
      type: String,
      default: 'DR'
    },
    accountId: {
      type: Number,
      default: null
    },
    transactionCurrency: {
      type: String,
      default: null
    },
    currencyForeign: {
      type: Object,
      default: () => ({})
    },
    transactionId: {
      type: Number,
      default: null
    },
    accountName: {
      type: String,
      default: ''
    },
    rate: {
      type: [String, Number],
      default: '0.00'
    },
    date: {
      type: String,
      default: null
    }
  },
  computed: {
    totalAmount() {
      const amount = this.form2.items.map(val => val.amount).reduce((sum, curr) => {
        return !curr ? sum : parseFloat(curr) + sum
      }, 0)
      return amount
    },
    totalAmountForeign() {
      const amount = this.form2.items.map(val => val.foreignAmount).reduce((sum, curr) => {
        return !curr ? sum : parseFloat(curr) + sum
      }, 0)
      return amount
    },
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    }
  },
  directives: {
    money: VMoney
  },
  data() {
    const validateAmount = (rule, value, callback) => {
      if (value <= 0) return callback(new Error(this.$t('modal_settings_fieldIsRequired')))
      callback();
    }
    return {
      validateAmount: validateAmount,
      money: {
        precision: 2,
        decimal: '.',
        thousands: ',',
        suffix: '',
        masked: false
      },
      moneySimple: {
        precision: 2,
        decimal: '.',
        thousands: ',',
        suffix: '',
        masked: false
      },
      moneyForeign: {
        precision: 2,
        decimal: '.',
        thousands: ',',
        suffix: '',
        masked: false
      },
      form2: {
        transactionDescription: null,
        items: [
          {
            amount: 0,
            foreignAmount: 0,
            transactionDescription: null,
            // TODO NEW
            entityTypeId: null,
            buId: null,
            parentId: null,
            taskId: null,
            vendorClientTypeId: null,
            vendorId: null,
            clientId: null,
            userId: null,
            // lists
            vendorList: [],
            clientList: [],
            buList: [],
            parentList: [],
            taskList: [],
            userList: []
          }
        ]
      },
      entityTypeList: [
        { id: 2, name: 'Business Unit', disabled: false },
        { id: 4, name: 'Warehouse', disabled: true },
        { id: 3, name: 'Engagement', disabled: false },
        { id: 1, name: 'Project', disabled: false },
      ],
      pickerOptions2: {
        disabledDate: this.disabledDates
      },
    }
  },
  methods: {
    openModal() {
      // console.log('this.companyLayout.currency.code', this.companyLayout.currency.code)
      // console.log('this.companyLayout.currency.code', this.currencyForeign.code)
      this.money.suffix = ' ' + this.companyLayout.currency.code
      this.moneyForeign.suffix = ' ' + this.currencyForeign.code
      this.$refs.modal.open()
    },
    async selectEntityType(scope) {
      const loader = this.$loading.show();
      try {
        scope.row.buId = null
        scope.row.parentId = null
        scope.row.taskId = null
        scope.row.userId = null
        scope.row.buList = []
        scope.row.parentList = []
        scope.row.taskList = []
        scope.row.userList = []

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();

        const response = await axios.post(`/api/v1/businessUnits/list?companyId=${this.$route.query.companyId}`)
        scope.row.buList = response.data.list

        loader.hide()

      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    async selectBu(scope) {
      scope.row.parentId = null
      scope.row.taskId = null
      scope.row.userId = null
      scope.row.parentList = []
      scope.row.taskList = []
      scope.row.userList = []

      try {
        const loader = this.$loading.show();
        console.log(scope)
        switch (scope.row.entityTypeId) {
          case 1:
            axios.get(`/api/v1/businessUnits/projectsListBU?businessUnitId=${scope.row.buId}`).then(response => {
              console.log('---', response.data)
              scope.row.parentList = response.data.list
              loader.hide()
            }).catch(err => {
              console.log(err)
              loader.hide()
            })
            break;
          case 2:
            axios.post(`/api/v1/businessUnitTasks/list?companyId=${this.$route.query.companyId}&businessUnitId=${scope.row.buId}`).then(response => {
              console.log('---', response.data)
              const list = response.data.newList
              list.shift()
              scope.row.taskList = list
              loader.hide()
            }).catch(err => {
              console.log(err)
              loader.hide()
            })
            break;
          case 3:
            axios.get(`/api/v1/businessUnits/engagementsListBU?businessUnitId=${scope.row.buId}`).then(response => {
              console.log('---', response.data)
              scope.row.parentList = response.data.list
              loader.hide()
            }).catch(err => {
              console.log(err)
              loader.hide()
            })
            break
        }
      } catch (err) {
        console.log(err)
      }
    },
    async selectParent(scope) {
      const loader = this.$loading.show();
      try {
        scope.row.taskId = null
        scope.row.taskList = []
        scope.row.userId = null
        scope.row.userList = []

        let url = ''
        switch (scope.row.entityTypeId) {
          case  1:
            url = `/api/v1/projectTasks/list?companyId=${this.$route.query.companyId}&projectId=${scope.row.parentId}`
            break;
          case 2:
            url = `/api/v1/businessUnitTasks/list?companyId=${this.$route.query.companyId}&businessUnitId=${scope.row.parentId}`
            break;
          case 3:
            url = `/api/v1/engagementTasks/list?companyId=${this.$route.query.companyId}&engagementId=${scope.row.parentId}`
            break
        }

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.post(url)
        loader.hide()
        const list = data.newList ? data.newList : data.newlist
        list.shift()
        scope.row.taskList = list
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    async selectTask(scope) {
      scope.row.userId = null
      scope.row.userList = []
      const loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        switch (scope.row.entityTypeId) {
          case 1:
            axios.post(`/api/v1/projectTasks/extendedInfo?companyId=${this.$route.query.companyId}&projectId=${scope.row.parentId}&projectTaskId=${scope.row.taskId}`).then(response => {
              scope.row.userList = response.data.extendedInfo.projectTaskCompanyUserList
              loader.hide()
            }).catch(err => {
              console.log(err)
              loader.hide()
            })
            break;
          case 2:
            axios.post(`/api/v1/businessUnitTasks/extendedInfo?companyId=${this.$route.query.companyId}&businessUnitId=${scope.row.buId}&businessUnitTaskId=${scope.row.taskId}`).then(response => {
              scope.row.userList = response.data.extendedInfo.businessUnitTaskCompanyUserList
              loader.hide()
            }).catch(err => {
              console.log(err)
              loader.hide()
            })
            break;
          case 3:
            axios.post(`/api/v1/engagementTasks/extendedInfo?companyId=${this.$route.query.companyId}&engagementId=${scope.row.parentId}&engagementTaskId=${scope.row.taskId}`).then(response => {
              scope.row.userList = response.data.extendedInfo.engagementTaskCompanyUserList
              loader.hide()
            }).catch(err => {
              console.log(err)
              loader.hide()
            })
            break;
        }
      } catch (err) {
        console.log(err)
      }
    },
    addItem(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const newItem = {
            amount: 0,
            foreignAmount: 0,
            transactionDescription: null,
            entityTypeId: null,
            buId: null,
            parentId: null,
            taskId: null,
            vendorClientTypeId: null,
            vendorId: null,
            clientId: null,
            userId: null,
            // lists
            vendorList: [],
            clientList: [],
            buList: [],
            parentList: [],
            taskList: [],
            userList: []
          }
          this.form2.items.push(newItem)
        }
      })
    },
    close() {
      this.money.suffix = ''
      this.moneyForeign.suffix = ''
      this.form2.transactionDescription = null
      this.form2.items = [{
        amount: 0,
        foreignAmount: 0,
        transactionDescription: null,
        entityTypeId: null,
        buId: null,
        parentId: null,
        taskId: null,
        vendorClientTypeId: null,
        vendorId: null,
        clientId: null,
        userId: null,
        // lists
        vendorList: [],
        clientList: [],
        buList: [],
        parentList: [],
        taskList: [],
        userList: []
      }]
      this.$refs['form2'].resetFields()
    },
    ifTotalAmountBigger() {
      return this.amount < this.totalAmount
    },
    ifTotalAmountForeignBigger() {
      return this.foreignAmount < this.totalAmountForeign
    },
    balanceToAllocate() {
      return this.amount - this.totalAmount
    },
    balanceToAllocateForeign() {
      return this.foreignAmount - this.totalAmountForeign
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    changeForeignAmount(row) {
      row.amount = (this.foreignAmount / this.amount) * row.foreignAmount
    },
    cellClick(val) {
      console.log('sssss', val)
    },
    addAllocations(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          const loader = this.$loading.show()
          const payload = {
            amount: this.totalAmount,
            foreignAmount: this.totalAmountForeign,
            transactionDescription: this.form2.transactionDescription,
            transactionId: 2,
            accountId: this.accountId,
            transactionCurrency: this.transactionCurrency,
            foreignCurrency: this.currencyForeign.code,
            allocationList: []
          }
          payload.allocationList  = this.form2.items.map(val => {
            return {
              amount: parseFloat(val.amount),
              foreignAmount: parseFloat(val.foreignAmount),
              transactionDescription: val.transactionDescription,
              entityTypeId: val.entityTypeId,
              parentId: val.buId && !val.parentId ? val.buId : val.parentId,
              taskId: val.taskId,
              vendorId: val.vendorId,
              clientId: val.clientId,
              userId: val.userId,
              buId: val.buId
            }
          })
          axios.post(`/api/v1/accountTransaction/createOpenBalanceAllocation?companyId=${this.$route.query.companyId}&parentTransactionId=${this.transactionId}`, payload).then(response => {
            loader.hide()
            this.notification("Success", "Allocations added", "success")
            this.$emit('loadItem')
            this.$refs.modal.close()
          }).catch(err => {
            console.log(err)
            loader.hide()
          })
        }
      })
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    disabledDates (time) {
      let start = time.getTime() < Number(moment().subtract(1, 'years').format('x'));
      let end = time.getTime() > Number(moment().format('x'));
      if (start){
        return start
      }else if(end){
        return end
      }
    },
  }
}
</script>

<style lang="less" scoped>
.content {
  &__head {
    display:flex;
    justify-content: space-between;
  }
}
.amount-input {
  display: block;
  resize: vertical;
  padding: 0 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 200px;
  font-size: inherit;
  color: #606266;
  background-color: #FFF;
  background-image: none;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  //transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  height: 33px;
  &:focus {
    outline: 0;
    border-color: #409EFF;
  }
  &.readonly {
    background: rgba(201, 202, 205, 0.5);
  }
}
.item-amount-input {
  display: block;
  resize: vertical;
  padding: 0 5px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  background-color: #FFF;
  background-image: none;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  //transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  height: 33px;
  &:focus {
    outline: 0;
    border-color: #409EFF;
  }
}
</style>
